import React from "react";
import Checkout from "../Ecomponents/Checkout/CheckoutForm";
// import Footer from '../components/Footer';
import Header from "../Ecomponents/Header/Header";
const CheckoutPage = () => {
    return(
    <>
        <Header/>
        <Checkout />
        {/* <Footer/> */}
    </>
    );
};

export default CheckoutPage;